import { render, staticRenderFns } from "./StaffsAndGroups.vue?vue&type=template&id=50ee732d"
import script from "./StaffsAndGroups.vue?vue&type=script&lang=ts"
export * from "./StaffsAndGroups.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports